import styled, { createGlobalStyle, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0); }
`

const c = {
  bg: '#0a0c0f', bg2: '#111318', bg3: '#181c23', bg4: '#1e2330',
  bdr: '#1f2430', bdr2: '#2a3040',
  acc: '#00e5a0', acc2: '#00b87a',
  adim: 'rgba(0,229,160,.08)', adim2: 'rgba(0,229,160,.18)',
  txt: '#e8ecf0', txt2: '#8a95a3', txt3: '#5a6370',
  warn: '#f59e0b', danger: '#ef4444', info: '#3b82f6',
  mono: "'Space Mono',monospace", sans: "'DM Sans',sans-serif",
}

export const GlobalDriverStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&display=swap');
`

export const PageWrap = styled.div`
  background:${c.bg}; color:${c.txt}; font-family:${c.sans};
  height:100vh; display:flex; flex-direction:column; overflow:hidden;
`

export const Topbar = styled.div`
  background:${c.bg2}; border-bottom:1px solid ${c.bdr};
  padding:10px 16px; height:48px;
  display:flex; align-items:center; gap:14px; flex-shrink:0;
  h2 { font-size:13px; font-weight:600; color:${c.txt}; }
  .crumb { font-size:11px; color:${c.txt3}; }
`

export const Body = styled.div`flex:1; display:flex; flex-direction:column; min-height:0;`

export const Toolbar = styled.div`
  display:flex; align-items:center; gap:12px; padding:14px 20px;
  background:${c.bg2}; border-bottom:1px solid ${c.bdr}; flex-shrink:0;
`
export const Search = styled.input`
  flex:1; max-width:380px; background:${c.bg3};
  border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:9px 12px; font-size:12px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const Stats = styled.div`
  display:flex; gap:14px; align-items:center; font-size:11px; color:${c.txt3};
  strong {
    color:${c.acc}; font-family:${c.mono}; font-size:14px;
    font-weight:700; margin-right:4px;
  }
`
export const NewBtn = styled.button`
  background:${c.acc}; border:none; color:#000;
  padding:9px 16px; border-radius:8px; cursor:pointer;
  font-size:12px; font-weight:700; font-family:${c.sans};
  transition:.15s; margin-left:auto;
  &:hover { filter:brightness(1.1); }
  &:disabled { opacity:.5; cursor:not-allowed; }
`
export const RefreshBtn = styled.button`
  background:${c.bg3}; border:1px solid ${c.bdr2}; color:${c.txt2};
  padding:8px 12px; border-radius:7px; font-size:11px; cursor:pointer;
  transition:.15s; font-family:${c.sans};
  &:hover { border-color:${c.acc}; color:${c.acc}; }
  &:disabled { opacity:.5; cursor:not-allowed; }
`

export const TableWrap = styled.div`
  flex:1; overflow:auto; padding:0 20px 40px;
  &::-webkit-scrollbar { width:6px; height:6px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }
`
export const Table = styled.div`
  display:table; width:100%; border-collapse:collapse; margin-top:14px;
  background:${c.bg2}; border:1px solid ${c.bdr}; border-radius:10px; overflow:hidden;
`
export const THead = styled.div`
  display:table-header-group; background:${c.bg3};
`
export const HRow = styled.div`
  display:table-row;
  & > div {
    display:table-cell; padding:11px 14px; font-size:10px;
    color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em;
    font-weight:600; border-bottom:1px solid ${c.bdr};
  }
`
export const Row = styled.div`
  display:table-row; transition:.12s;
  animation:${fadeIn} .2s ease;
  &:hover { background:${c.bg3}; }
  & > div {
    display:table-cell; padding:13px 14px; font-size:12px;
    color:${c.txt}; vertical-align:middle;
    border-bottom:1px solid ${c.bdr};
  }
  &:last-child > div { border-bottom:none; }
`

export const CellName = styled.div`
  font-weight:600;
  .doc { font-family:${c.mono}; font-size:10px; color:${c.txt3}; margin-top:2px; display:block; }
`
export const CellMono = styled.div`
  font-family:${c.mono}; font-size:11px; color:${c.txt2};
  span.unit { color:${c.txt3}; font-size:10px; margin-left:3px; }
`
export const CellCheck = styled.div`
  font-family:${c.mono}; font-size:11px;
  color:${({ $on }) => $on ? c.acc : c.txt3};
  &::before { content: ${({ $on }) => $on ? '"✓"' : '"—"'}; margin-right:4px; }
`
export const CarrierChips = styled.div`
  display:flex; gap:4px; flex-wrap:wrap; max-width:260px;
  .chip {
    background:${c.bg4}; border:1px solid ${c.bdr2}; border-radius:5px;
    padding:3px 8px; font-size:10px; color:${c.txt2}; white-space:nowrap;
  }
  .more {
    background:transparent; color:${c.acc}; padding:3px 6px;
    font-size:10px; font-weight:600;
  }
`
export const StatusBadge = styled.div`
  display:inline-flex; align-items:center; gap:5px;
  background:${({ $on }) => $on ? 'rgba(0,229,160,.12)' : 'rgba(94,99,112,.18)'};
  border:1px solid ${({ $on }) => $on ? c.acc2 : c.bdr2};
  color:${({ $on }) => $on ? c.acc : c.txt3};
  padding:3px 9px; border-radius:11px;
  font-size:10px; font-weight:600;
  &::before {
    content:''; width:6px; height:6px; border-radius:50%;
    background:${({ $on }) => $on ? c.acc : c.txt3};
  }
`

export const Actions = styled.div`
  display:flex; gap:4px; justify-content:flex-end;
`
export const IconBtn = styled.button`
  background:transparent; border:1px solid ${c.bdr2}; border-radius:6px;
  width:30px; height:30px; cursor:pointer; transition:.12s;
  font-size:13px; color:${c.txt3}; padding:0;
  display:inline-flex; align-items:center; justify-content:center;
  &:hover {
    border-color:${({ $danger }) => $danger ? c.danger : c.warn};
    color:${({ $danger }) => $danger ? c.danger : c.warn};
    background:${({ $danger }) => $danger ? 'rgba(239,68,68,.08)' : 'rgba(245,158,11,.08)'};
  }
  &:disabled { opacity:.4; cursor:not-allowed; pointer-events:none; }
`

export const Empty = styled.div`
  text-align:center; padding:50px 20px; color:${c.txt3}; font-size:13px;
  background:${c.bg2}; border:1px dashed ${c.bdr2}; border-radius:10px;
  margin-top:14px;
  strong { color:${c.acc}; }
`
export const Loading = styled.div`
  text-align:center; padding:40px 20px; color:${c.txt3}; font-size:12px;
`

// ─── MODAL (form) ───────────────────────────────────────────────────────────
export const ModalOverlay = styled.div`
  position:fixed; inset:0; z-index:2000;
  background:rgba(0,0,0,.6); backdrop-filter:blur(2px);
  display:${({ $visible }) => $visible ? 'flex' : 'none'};
  align-items:center; justify-content:center;
`
export const ModalBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:22px 24px; width:520px; max-width:calc(100vw - 40px);
  max-height:calc(100vh - 80px); overflow-y:auto;
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  h3 { font-size:15px; font-weight:600; margin-bottom:6px; color:${c.txt}; }
  p { font-size:12px; color:${c.txt3}; margin-bottom:14px; line-height:1.5; }
  &::-webkit-scrollbar { width:5px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:3px; }
`

export const Label = styled.div`
  font-size:10px; color:${c.txt3}; text-transform:uppercase; letter-spacing:.06em;
  margin:14px 0 6px;
  .opt { text-transform:none; opacity:.6; margin-left:5px; }
`
export const Input = styled.input`
  width:100%; background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  color:${c.txt}; padding:10px 12px; font-size:13px; font-family:${c.sans}; outline:none;
  &:focus { border-color:${c.acc}; }
  &::placeholder { color:${c.txt3}; }
`
export const TwoCols = styled.div`
  display:grid; grid-template-columns:1fr 1fr; gap:14px;
`

export const CheckRow = styled.label`
  display:flex; align-items:flex-start; gap:9px;
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  padding:10px 12px; cursor:pointer; transition:.12s;
  &:hover { border-color:${c.bdr2}; background:${c.bg4}; }
  ${({ $checked }) => $checked && `
    border-color: #00b87a;
    background: rgba(0,229,160,.06);
  `}
  input { margin-top:2px; accent-color:#00e5a0; cursor:pointer; }
  .lbl { font-size:12px; color:#e8ecf0; font-weight:500; line-height:1.3; }
  .hint { font-size:10px; color:#5a6370; margin-top:3px; line-height:1.4; }
`

export const StatusToggle = styled.div`
  display:flex; align-items:center; gap:10px;
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  padding:10px 12px;
  .lbl { flex:1; font-size:12px; color:${c.txt}; }
  .hint { font-size:10px; color:${c.txt3}; margin-top:2px; display:block; }
`
export const Switch = styled.button`
  position:relative; width:42px; height:22px; border:none; border-radius:11px;
  background:${({ $on }) => $on ? c.acc : c.bdr2};
  cursor:pointer; transition:.18s;
  flex-shrink:0;
  &::after {
    content:''; position:absolute; top:2px; left:${({ $on }) => $on ? '22px' : '2px'};
    width:18px; height:18px; border-radius:50%;
    background:#fff; transition:.18s;
  }
`

// Multi-select de transportadoras
export const MultiSelectWrap = styled.div`
  background:${c.bg3}; border:1px solid ${c.bdr2}; border-radius:8px;
  max-height:200px; overflow-y:auto;
  &::-webkit-scrollbar { width:4px; }
  &::-webkit-scrollbar-thumb { background:${c.bdr2}; border-radius:2px; }
`
export const MSItem = styled.label`
  display:flex; align-items:center; gap:9px; padding:9px 12px;
  border-bottom:1px solid ${c.bdr}; cursor:pointer; transition:.1s;
  &:last-child { border-bottom:none; }
  &:hover { background:${c.bg4}; }
  ${({ $checked }) => $checked && `
    background: rgba(0,229,160,.06);
  `}
  input { accent-color:#00e5a0; cursor:pointer; }
  .name { font-size:12px; color:#e8ecf0; flex:1; }
  .doc { font-family:'Space Mono',monospace; font-size:10px; color:#5a6370; }
`
export const MSEmpty = styled.div`
  padding:14px; text-align:center; font-size:11px; color:${c.txt3};
`
export const SelectedCount = styled.div`
  font-size:10px; color:${c.txt3}; margin-top:6px; font-family:${c.mono};
  span { color:${c.acc}; font-weight:700; }
`

export const ModalActions = styled.div`
  display:flex; justify-content:flex-end; gap:8px; margin-top:20px;
`
export const ModalBtn = styled.button`
  padding:8px 18px; border-radius:7px; cursor:pointer;
  font-size:12px; font-weight:600; transition:.15s; font-family:${c.sans};
  background:${({ $primary }) => $primary ? c.acc : 'transparent'};
  border:1px solid ${({ $primary }) => $primary ? c.acc : c.bdr2};
  color:${({ $primary }) => $primary ? '#000' : c.txt2};
  &:hover { ${({ $primary }) => $primary ? 'filter:brightness(1.1);' : `border-color:${c.acc}; color:${c.acc};`} }
  &:disabled { opacity:.5; cursor:not-allowed; }
`

// ─── CONFIRM MODAL ───────────────────────────────────────────────────────────
export const ConfirmBox = styled.div`
  background:${c.bg2}; border:1px solid ${c.bdr2}; border-radius:12px;
  padding:22px 24px; min-width:340px; max-width:440px;
  box-shadow:0 16px 48px rgba(0,0,0,.7);
  border-top:3px solid ${({ $tone }) => $tone === 'danger' ? c.danger : c.warn};
`
export const ConfirmIcon = styled.div`
  width:42px; height:42px; border-radius:50%;
  background:${({ $tone }) => $tone === 'danger' ? 'rgba(239,68,68,.15)' : 'rgba(245,158,11,.15)'};
  color:${({ $tone }) => $tone === 'danger' ? c.danger : c.warn};
  display:flex; align-items:center; justify-content:center;
  font-size:22px; margin-bottom:12px;
`
export const ConfirmTitle = styled.h3`
  font-size:15px; font-weight:600; color:${c.txt}; margin-bottom:6px;
`
export const ConfirmMessage = styled.p`
  font-size:12px; color:${c.txt2}; line-height:1.6; margin-bottom:18px;
  white-space:pre-line;
`
export const ConfirmActions = styled.div`
  display:flex; justify-content:flex-end; gap:8px;
`
export const ConfirmBtn = styled.button`
  padding:8px 18px; border-radius:7px; cursor:pointer;
  font-size:12px; font-weight:600; transition:.15s; font-family:${c.sans};
  background:${({ $primary, $tone }) =>
    $primary ? ($tone === 'danger' ? c.danger : c.warn) : 'transparent'};
  border:1px solid ${({ $primary, $tone }) =>
    $primary ? ($tone === 'danger' ? c.danger : c.warn) : c.bdr2};
  color:${({ $primary }) => $primary ? '#fff' : c.txt2};
  &:hover { ${({ $primary }) => $primary ? 'filter:brightness(1.1);' : `border-color:${c.acc}; color:${c.acc};`} }
`
